import { Component, OnInit } from '@angular/core';
import { environment } from 'src/app/environment';
import { CadastroUsuario } from '../../entity/CadastroUsuario';
import { AuthService } from '../../service/autenticacao/auth.service';
import { Router } from '@angular/router';
import { EDITAR_USUARIO, PAGINA_HOME_USUARIO_INTERNO, PESQUISAR_MANIFESTO_USUARIO } from 'src/app/tools/URL';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  title = 'canalunico';
  ambiente: string;
  dataAtual: number = Date.now();

  constructor(private authService: AuthService, private router: Router) {
    this.ambiente = environment.settings.ambiente;
  }

  ngOnInit() {
    this.refreshData();
  }

  refreshData() {

    setInterval(() => {
      this.dataAtual = Date.now();
    }, 1000);

  }

  get retornarAmbiente() {

    switch (this.ambiente) {
      case 'produção': return '';
      case 'desenvolvimento': return 'Ambiente: Desenvolvimento';
      case 'homologação': return 'Ambiente: Homologação';
    }

    return null;

  }

  meusDados() {
    this.router.navigate([EDITAR_USUARIO]);
  }

  minhasDemandas() {
    this.router.navigate([PESQUISAR_MANIFESTO_USUARIO]);
  }

  get isUsuarioExternoLogado(): boolean {

    return this.authService.isUsuarioExternoLogado();

  }

  get isUsuarioGovBr(): boolean {

    return this.authService.isUsuarioGovBr();

  }

  get isUsuarioInternoLogado(): boolean {

    return !this.isUsuarioExternoLogado && !this.isUsuarioGovBr && this.usuarioLogado.nome !== '';

  }

  get usuarioLogado(): CadastroUsuario {

    return this.authService.usuarioLogado;

  }

  usuarioInternoPaginaInicial() {

    this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);

  }

  logout() {

    this.authService.logoutUser();

  }

  logoutGovBr() {

    this.authService.logoutUserGovBr();

  }

}
